export const sideCarousel = {
  slides: {
    qualityProgram: {
      title: "[Placeholder] A higher standard for your health",
      body: "[Placeholder] Access trusted supplements, labs, and wellness products backed by our quality program.",
    },
    mobileApp: {
      title: "[Placeholder] Patients love Fullscript even more on the app",
      body: "[Placeholder] Scan to download the free Fullscript app.",
    },
  },
} as const;
